import { FormTemplatesTypes } from '../../../types';
import { BASE_ROUTE } from '../base';
import { RouterPayload } from '../route.types';
import { BASE_FORMS_TEMPLATES_ROUTE } from './form-templates.constants';

export interface FormTemplatesListRoutePayload {
  view?: FormTemplatesTypes.View;
  sort?: FormTemplatesTypes.SortBy;
  relativePath?: boolean;
}

export function getFormTemplatesListRoute(payload: FormTemplatesListRoutePayload = {}): RouterPayload {
  const { view = 'grid', sort = 'name--asc', relativePath = false } = payload;
  const path = relativePath ? BASE_FORMS_TEMPLATES_ROUTE.split(BASE_ROUTE)[1] : BASE_FORMS_TEMPLATES_ROUTE;
  const searchParams: Record<string, string> = {
    view,
    sort,
  };

  return {
    to: path,
    search: searchParams,
  };
}

export interface FormTemplateDetailsRoutePayload extends FormTemplatesListRoutePayload {
  locationId?: string;
  templateId?: string;
}

export function getFormTemplateDetailsV2Route(payload: FormTemplateDetailsRoutePayload = {}): RouterPayload {
  const { templateId, locationId, ...rest } = payload;
  const listRoute = getFormTemplatesListRoute(rest);
  const searchParams = { ...(listRoute.search || {}) };

  if (templateId) {
    searchParams.templateId = templateId;
  }

  if (locationId) {
    searchParams.locationId = locationId;
  }

  return {
    to: listRoute.to,
    search: searchParams,
  };
}
